import React, { useEffect } from 'react';
import { TextInput } from '@mantine/core';
import { useProductQuiz } from '../ProductQuizContext';
import { QuestionTitle } from './QuestionTitle';
import { QuestionNextButton } from './QuestionNextButton';
import { quizQuestionPage } from '../../../lib/analytics/events';
import { useTranslation } from 'react-i18next';

export const QuestionName: React.FC = () => {
  const { t } = useTranslation();
  useEffect(() => {
    quizQuestionPage.quizPetNamePageEntered();
  }, []);

  const { quizAnswers, setQuizAnswers, nextQuestion } = useProductQuiz();

  return (
    <>
      <QuestionTitle>{t('whats_your_species_name', { species: quizAnswers.species ?? '' })}</QuestionTitle>
      <TextInput
        autoFocus
        placeholder={t('placeholder_pet_name')}
        radius="xl"
        value={quizAnswers.petName ?? ''}
        sx={{ input: { height: 56, fontSize: 16, paddingLeft: '2em', paddingRight: 10, enterkeyhint: 'next' } }}
        onChange={(e) => {
          setQuizAnswers({ ...quizAnswers, petName: e.target.value });
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            if (quizAnswers.petName) {
              quizQuestionPage.quizPetNameNext(quizAnswers.petName ?? '');
              nextQuestion();
            }
          }
        }}
      />
      <QuestionNextButton
        showOnDesktop={true}
        isDisabled={!quizAnswers.petName}
        event={() => quizQuestionPage.quizPetNameNext(quizAnswers.petName ?? '')}
      />
    </>
  );
};
